module.exports = __webpack_public_path__ + "media/images/front/icon_comment-7fdc4716e3315d606f5123c2da95412e.png";